import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'
import usePopup, { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import {
  AddToMyVendorsPopupPayload,
  UpgradeToFullAccessPopupPayload
} from '../VendorsList/types'
import {
  addToMyVendorsPopupWithPayload,
  upgradeToFullAccessPopupWithPayload
} from './constants'

type ContextProps = {
  addToMyVendorsPopup: PopupReturnTypeWithPayload<AddToMyVendorsPopupPayload>
  upgradeToFullAccessPopup: PopupReturnTypeWithPayload<UpgradeToFullAccessPopupPayload>
}

const basePopup = (title: string) => ({
  title
})

const VendorsPagePopupContext = createContext<ContextProps>({
  addToMyVendorsPopup: addToMyVendorsPopupWithPayload,
  upgradeToFullAccessPopup: upgradeToFullAccessPopupWithPayload
})

const VendorsPagePopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const addToMyVendorsPopupProps = usePopup<AddToMyVendorsPopupPayload>(
    basePopup('')
  )
  const upgradeToFullAccessPopupProps =
    usePopup<UpgradeToFullAccessPopupPayload>(
      basePopup('Upgrade access type of Vendor to Full Access')
    )

  const context = useMemo(
    () => ({
      addToMyVendorsPopup: addToMyVendorsPopupProps,
      upgradeToFullAccessPopup: upgradeToFullAccessPopupProps
    }),
    [addToMyVendorsPopupProps, upgradeToFullAccessPopupProps]
  )

  return (
    <VendorsPagePopupContext.Provider value={context}>
      {children}
    </VendorsPagePopupContext.Provider>
  )
}

export const useVendorsPagePopup = () => useContext(VendorsPagePopupContext)

export default VendorsPagePopupProvider
